module.exports = __webpack_public_path__ + "blush.svg?d82563e27dcca755afc6e3773a5f7d3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feelings2/blush.svg
// module id = 90
// module chunks = 0